import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../../utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter ? `, filter: ${convertFilterRequestUrl(filter, [])}` : '';
  const getEnergyTopupReport = `getEnergyTopupReport(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${getEnergyTopupReport} {
        id
        accountId
        subscriptionId
        userId
        createdDate
        paymentSource
        paymentRefId
        paymentSourceId
        paymentDescription
        amount
        approximateKwh
        serviceType
      }
    }
  `;
};
